module.exports = __webpack_public_path__ + "fonts/f673d05.ttf";